
/*!


=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useState } from "react";
// reactstrap components
import {
    Card, CardHeader, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Button, Badge, CardImgOverlay
} from 'reactstrap';
import { Container, Row, Col } from 'reactstrap';
//import Modal from 'react-bootstrap/Modal';
import { FormGroup, Label, Input, FormText } from 'reactstrap';
import { TabContent, TabPane, NavItem, NavLink, Media } from 'reactstrap';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import FormCheck from 'react-bootstrap/FormCheck';
import { Alert } from 'reactstrap';

import classnames from 'classnames';
import empleadoimg from '../assets/img/empleado.png';
import { BsFillEyeFill, BsPencilSquare, BsFillTrashFill, BsBookmarksFill } from 'react-icons/bs';
import { useEffect } from 'react';
import { id } from "date-fns/locale";
import MaterialTable, { MTableToolbar } from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { unregister } from "../Interceptor.js";
import { isExpired, decodeToken } from "react-jwt";
import AlertTitle from "@material-ui/lab/AlertTitle";
import { createTheme } from '@material-ui/core/styles';
import moment from 'moment';

const tableIcons = {
    Add: React.forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: React.forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: React.forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: React.forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: React.forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: React.forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: React.forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: React.forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: React.forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: React.forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: React.forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: React.forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: React.forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

var dataTiposIdenPersona = [{}];
var dataPaises = [{}];
var dataDepartamentos = [{}];
var dataCiudades = [{}];
var datatipoContrato = [{}];
var datatipoTrabajador = [{}];
var datatipoSubTrabajador = [{}];
var dataBancos = [{}];
var dataFormaPagos = [{}];
var dataNovedades = [{}];


function Icons() {

    useEffect(() => {
        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }
        login();
        selectDataIdentLoad();
        selectDataPaisesLoad();
        selectDataDepartamentosLoad(44);
        selectDataCiudadesLoad(5);
        selectdatatipoContratoLoad();
        selectdatatipoSubTrabajadorLoad();
        selectdatatipoTrabajadorLoad();
        selectDataBancosLoad();
        selectDataFormaPagoLoad();
        gettiposNovedad();
    }, []);

    const [loading, setLoading] = React.useState(false);

    //----------------------------Datos Generales-------------------------------

    const [show, setShow] = React.useState(false);
    const [showCreate, setShowCreate] = React.useState(false);
    const [showEdit, setShowEdit] = React.useState(false);

    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState("");

    const onDismiss = () => setVisible(false);

    const [idCliente, setidCliente] = React.useState(0);

    const [empleadosDatos, setEmpleadosDatos] = React.useState([]);
    const [nombre1Empleado, setNombre1Empleado] = React.useState("");
    const handleNombre1 = (e) => { setNombre1Empleado(e.target.value); }
    const [nombre2Empleado, setNombre2Empleado] = React.useState("");
    const handleNombre2 = (e) => { setNombre2Empleado(e.target.value); }
    const [Apellido1Empleado, setApellido1Empleado] = React.useState("");
    const handleApellido1 = (e) => { setApellido1Empleado(e.target.value); }
    const [Apellido2Empleado, setApellido2Empleado] = React.useState("");
    const handleApellido2 = (e) => { setApellido2Empleado(e.target.value); }
    const [iDInterno, setiDInterno] = React.useState("");
    const handleiDInterno = (e) => { setiDInterno(e.target.value); }
    const [tipoIdentificacion, settipoIdentificacion] = React.useState(0);
    const handletipoIdentificacion = (e) => { settipoIdentificacion(e.target.value); }
    const [identificacion, setIdentificacion] = React.useState("");
    const handleidentificacion = (e) => { setIdentificacion(e.target.value); }
    const [correo, setCorreo] = React.useState("");
    const handlecorreo = (e) => { setCorreo(e.target.value); }
    const [Telefono, setTelefono] = React.useState("");
    const handleTelefono = (e) => { setTelefono(e.target.value); }
    const [Ubicacion, setUbicacion] = React.useState("");
    const handleUbicacion = (e) => { setUbicacion(e.target.value); }
    const [IdPais, setIdPais] = React.useState(0);
    const handleIdPais = (e) => {
        setIdPais(e.target.value);
        selectDataDepartamentosLoad(e.target.value);
        console.log(e.target.value);
    }
    const [IdDepartamento, setIdDepartamento] = React.useState(14);
    const handleIdDepartamento = (e) => {
        setIdDepartamento(e.target.value);
        selectDataCiudadesLoad(e.target.value);
        console.log(e.target.value);
    }
    const [IdMunicipio, setIdMunicipio] = React.useState(0);
    const handleIdMunicipio = (e) => {
        setIdMunicipio(e.target.value);
        console.log(e.target.value);
    }
    const [fechaIngreso, setfechaIngreso] = React.useState(moment()
        .locale('en')
        .format('YYYY-MM-DD'));
    const handlefechaIngreso = (e) => {

        setfechaIngreso(e.target.value);
    }
    const login = () => {


        //myHeaders.append("Content-Type", "application/json");
        //myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));


        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        const apiUrl = './api/Empleado/Empleados';
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    var emp = data.basePresentationList;
                    console.log(data);
                    
                    if (emp == null) {
                        setShowAlertaNoEmp(true);
                    } else {
                        setEmpleadosDatos(emp);
                    }
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )
    }
    const [dataTiposIdentificacionPersonas, setDataIden] = React.useState([]);
    const selectDataIdentLoad = () => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaTiposIdentificacion", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataTiposIdenPersona = result.basePresentationList;
                console.log(dataTiposIdenPersona);
                setDataIden(dataTiposIdenPersona);
            })
            .catch(error => console.log('error', error));
    }
    const [dataPaisesLista, setDataPaises] = React.useState(dataPaises);
    const [dataDepartamentosLista, setDataDepts] = React.useState(dataDepartamentos);
    const [dataCiudadLista, setDataCiudades] = React.useState(dataCiudades);
    const selectDataPaisesLoad = () => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaPaises", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataPaises = result.basePresentationList;
                console.log(dataPaises);
                setDataPaises(dataPaises);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataDepartamentosLoad = (pais) => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaDepartamentosPais?iIdPais=" + String(pais)

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataDepartamentos = result.basePresentationList;
                console.log(dataDepartamentos);
                setDataDepts(dataDepartamentos);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataCiudadesLoad = (ciudad, ciudadOpcional) => {

        console.log(ciudadOpcional);

        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaMuniciposDepartamento?iIdDepartamento=" + String(ciudad)

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataCiudades = result.basePresentationList;
                console.log(dataCiudades);
                setDataCiudades(dataCiudades);
                console.log(ciudadOpcional);
                if (ciudadOpcional != undefined) {
                    console.log(ciudadOpcional);
                    setIdMunicipio(ciudadOpcional);
                }
            })
            .catch(error => console.log('error', error));
    }

    //----------------------------Datos Laborales-------------------------------

    const [IdtipoContrato, setIdtipoContrato] = React.useState(0);
    const handleIdtipoContrato = (e) => {
        setIdtipoContrato(e.target.value);
    }
    const [datatipoContratoLista, settipoContrato] = React.useState(datatipoContrato);

    const [IdtipoTrabajador, setIdtipoTrabajador] = React.useState(0);
    const handleIdtipoTrabajador = (e) => {
        setIdtipoTrabajador(e.target.value);
    }
    const [datatipoTrabajadorLista, settipoTrabajador] = React.useState(datatipoTrabajador);

    const [IdtipoSubTrabajador, setIdtipoSubTrabajador] = React.useState(0);
    const handleIdtipoSubTrabajador = (e) => {
        setIdtipoSubTrabajador(e.target.value);
    }
    const [datatipoSubTrabajadorLista, settipoSubTrabajador] = React.useState(datatipoSubTrabajador);

    const selectdatatipoContratoLoad = () => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaTipoContrato", requestOptions)
            .then(response => response.json())
            .then(result => {
                datatipoContrato = result.basePresentationList;
                console.log(datatipoContrato);
                settipoContrato(datatipoContrato);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }

    const selectdatatipoTrabajadorLoad = () => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaTipoTrabajador", requestOptions)
            .then(response => response.json())
            .then(result => {
                datatipoTrabajador = result.basePresentationList;
                console.log(datatipoTrabajador);
                settipoTrabajador(datatipoTrabajador);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }

    const selectdatatipoSubTrabajadorLoad = () => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaTipoSubTrabajador", requestOptions)
            .then(response => response.json())
            .then(result => {
                datatipoSubTrabajador = result.basePresentationList;
                console.log(datatipoSubTrabajador);
                settipoSubTrabajador(datatipoSubTrabajador);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }
    const [SalarioIntegral, setSalarioIntegral] = React.useState(false);
    const handleSalarioIntegral = (e) => {
        setSalarioIntegral(e.target.checked);
    }
    const [Sueldo, setSueldo] = React.useState(0);
    const handleSueldo = (e) => { setSueldo(e.target.value); }

    const [IdBanco, setIdBanco] = React.useState(0);
    const handleIdBanco = (e) => {
        setIdBanco(e.target.value);
    }
    const [dataBancosLista, setBancos] = React.useState(dataBancos);

    //---------------------Tipos de cuenta-faltante

    const [NumeroCuenta, setNumeroCuenta] = React.useState("");
    const handleNumeroCuenta = (e) => { setNumeroCuenta(e.target.value); }

    const [IdFormaPago, setIdFormaPago] = React.useState(0);
    const handleIdFormaPago = (e) => {
        setIdFormaPago(e.target.value);
    }
    const [dataFormaPagoLista, setFormaPagos] = React.useState(dataFormaPagos);

    const [novedades, setNovedades] = React.useState([]);

    const selectDataBancosLoad = () => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaBancos"

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataBancos = result.basePresentationList;
                console.log(dataBancos);
                setBancos(dataBancos);
            })
            .catch(error => console.log('error', error));
    }

    const selectDataFormaPagoLoad = () => {



        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaFormasPago"

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataFormaPagos = result.basePresentationList;
                console.log(dataFormaPagos);
                setFormaPagos(dataFormaPagos);
            })
            .catch(error => console.log('error', error));
    }

    const handleClose = () => setShow(false);

    const handleShow = (e) => {
        setShow(true);
        const index = e.target.getAttribute("data-tag");
        const tag = e.target.getAttribute("data-index");
        console.log(tag);

        if (tag == "0") {
            setShowEdit(false);
            setShowCreate(false);
        } else if (tag == "1") {
            setShowEdit(true);
            setShowCreate(false);
        } else {
            setShowCreate(true);
            setShowEdit(false);
        }



        const empleado = empleadosDatos[index];
        if (tag == "2") {
            setNombre1Empleado("");
            setNombre2Empleado("");
            setApellido1Empleado("");
            setApellido2Empleado("");
            setiDInterno("");
            settipoIdentificacion(1);
            setIdentificacion("");
            setCorreo("");
            setTelefono("");
            setUbicacion("");
            setIdPais(44);
            setIdDepartamento(14);
            setIdMunicipio(1);
            setIdtipoContrato(1) == null ? "1" : "2";
            setIdtipoTrabajador(1) == null ? "1" : "2";
            setIdtipoSubTrabajador(1) == null ? "1" : "2";
            setSalarioIntegral(false);
            setSueldo(0);
            setIdBanco(1);
            //SetitpodeCuenta
            setNumeroCuenta("");
            setIdFormaPago(1);
            setidCliente(0);
        } else {

            if (empleado != null) {
                console.log(empleado);
                setNombre1Empleado(empleado.PrimerNombre);
                setNombre2Empleado(empleado.OtroNombre);
                setApellido1Empleado(empleado.PrimerApellido);
                setApellido2Empleado(empleado.SegundoApellido);
                setiDInterno(empleado.CodigoCliente);
                settipoIdentificacion(empleado.TipoIdentificacion);
                setIdentificacion(empleado.RFC);
                setCorreo(empleado.CorreoElectronico);
                setTelefono(empleado.TelefonoEmpleadoString);
                setUbicacion(empleado.DireccionEmpleado);
                setIdPais(empleado.Pais);
                setIdDepartamento(empleado.Departamento);
                selectDataCiudadesLoad(empleado.Departamento, empleado.Municipio);
                setIdMunicipio(empleado.Municipio);
                setIdtipoContrato(empleado.TipoContrato) == null ? "1" : "2";
                setIdtipoTrabajador(empleado.TipoTrabajador) == null ? "1" : "2";
                setIdtipoSubTrabajador(empleado.SubTipoTrabajador) == null ? "1" : "2";
                setSalarioIntegral(empleado.SalarioIntegral);
                setSueldo(empleado.Sueldo);
                setIdBanco(empleado.Banco);
                //SetitpodeCuenta "01/12/2021" 2021-01-12
                var curr = new Date(empleado.FechaIngreso);
                curr.setDate(curr.getDate());
                var date = curr.toISOString().substr(0, 10);

                setfechaIngreso(moment(curr)
                    .locale('en')
                    .format('YYYY-MM-DD'));
                console.log(date);
                setNumeroCuenta(empleado.NumeroCuenta);
                setIdFormaPago(empleado.FormaPago);
                setidCliente(empleado.IdEmpleado);

            }
        }

    };
    const [activeTab, setActiveTab] = useState('1');

    var formatter = formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'COP',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const [showNovedades, setShowNovedades] = useState(false);

    const handleCloseNovedades = () => {
        setShowNovedades(false);
        window.location.reload(false);
    };

    const handleShowNovedades = (e) => {
        const tag = e.target.getAttribute("data-index");

        if (tag == "4") {
            //window.location.reload(false);
            setShowNovedades(true);
            const index = e.target.getAttribute("data-tag");
            const empleado = empleadosDatos[index];
            console.log(empleado);
            if (empleado == null) {

            } else {
                console.log(empleado);
                setidCliente(empleado.IdEmpleado);
                getNovedadesEmpleados(empleado.IdEmpleado);
            }

        } else {
            setShowNovedades(false);
            const index = e.target.getAttribute("data-tag");
            const empleado = empleadosDatos[index];
            console.log(empleado);
            if (empleado == null) {

            } else {
                console.log(empleado);
                setidCliente(empleado.IdEmpleado);
                //deleteEmpleado(empleado.id_cliente);
                setShowEliminar(true);
            }
        }
    };

    const confirmarEliminar = () => {
        deleteEmpleado(idCliente);
    }

    const renderCard = (card, index) => {

        return (
            <Col
                className="font-icon-list col-xs-6 col-xs-6"
                lg="3"
                md="4"
                sm="5"
            >
                <Card key={index} style={{ fontFamily: 'Hammersmith One' }} >
                    <CardImg top width="100%" src={empleadoimg} alt="Card image cap" />

                    <CardImgOverlay>
                        <Row style={{ margin: "1px" }}>
                            <Badge key={index} style={{ cursor: "pointer" }} data-index={"4"} data-tag={index} color="info" onClick={handleShowNovedades} pill><BsBookmarksFill />Novedades </Badge>

                        </Row>
                        <Row style={{ margin: "1px", marginTop: "5px" }}>
                            <Badge key={index} style={{ cursor: "pointer" }} data-index={"0"} data-tag={index} onClick={handleShow} color="success" pill><BsFillEyeFill /> Ver</Badge>
                        </Row>
                        <Row style={{ margin: "1px", marginTop: "5px" }}>
                            <Badge key={index} style={{ cursor: "pointer" }} data-index={"1"} data-tag={index} onClick={handleShow} color="warning" pill><BsPencilSquare /> Editar</Badge>
                        </Row>
                        <Row style={{ margin: "1px", marginTop: "5px" }}>
                            <Badge key={index} style={{ cursor: "pointer" }} data-index={"3"} data-tag={index} color="danger" onClick={handleShowNovedades} pill><BsFillTrashFill /> Eliminar</Badge>
                        </Row>
                    </CardImgOverlay>
                    <CardBody>
                        <Row>
                            <Col md="12">
                                <CardTitle tag="h5">{card.PrimerNombre + " " + card.PrimerApellido + " " + card.SegundoApellido}</CardTitle>
                                <CardSubtitle tag="h6" className="mb-2 text-muted" >{card.CodigoCliente}</CardSubtitle>

                            </Col>

                        </Row>
                        <Row>
                            <Col md="4">

                                {/*<Button key={index} data-index={"0"} data-tag={index} onClick={handleShow} style={{ width: "10px", height: "30px", borderRadius: "1rem", background: "#1d8cf8" }}>
                                    <BsFillEyeFill style={{ marginTop: "-10px", marginLeft: "-5px" }} /> Ver
                                </Button>*/}
                            </Col>
                            <Col md="4">

                                {/*<Button key={index} data-index={"1"} data-tag={index} onClick={handleShow} style={{ width: "10px", height: "30px", borderRadius: "1rem", background: "#1d8cf8" }}>
                                    <BsPencilSquare style={{ marginTop: "-10px", marginLeft: "-5px" }} /> Ver
                                </Button>*/}
                            </Col>
                            <Col md="4">

                            </Col>
                            <Col md="4">

                            </Col>
                            <Col md="12">

                            </Col>

                        </Row>
                    </CardBody>
                </Card>
            </Col>
        )
    }

    const updateEmpleado = () => {



        var suledodecimal = parseFloat(Sueldo);
        console.log(Sueldo);
        console.log(suledodecimal);

        var raw = JSON.stringify({
            "IdEmpleado": idCliente,
            "id_empresa": localStorage.getItem('idEmpresa'),
            "Nombre": nombre1Empleado + " " + Apellido1Empleado,
            "RFC": identificacion,
            "NumeroEmpleado": iDInterno,
            "TipoIdentificacion": tipoIdentificacion,
            "TelefonoEmpleadoString": Telefono,
            "CorreoElectronico": correo,
            "PrimerNombre": nombre1Empleado,
            "OtroNombre": nombre2Empleado,
            "PrimerApellido": Apellido1Empleado,
            "SegundoApellido": Apellido2Empleado,
            "SalarioIntegral": SalarioIntegral,
            "Sueldo": Sueldo,
            "NumeroCuenta": NumeroCuenta,
            "DireccionEmpleado": Ubicacion,
            "Banco": IdBanco,
            "TipoCuenta": 1,
            "FormaPago": IdFormaPago,
            "MedioPago": 1,
            "Municipio": IdMunicipio,
            "Departamento": IdDepartamento,
            "Pais": IdPais,
            "SubTipoTrabajador": IdtipoSubTrabajador,
            "TipoTrabajador": IdtipoTrabajador,
            "TipoContrato": IdtipoContrato,
            "FechaIngreso": fechaIngreso
        });

        console.log(raw);

        var requestOptions = {
            method: 'PUT',
            headers: new Headers(),
            body: raw,
            redirect: 'follow'
        };
        //\u00f3n
        fetch("./api/Empleado/ActualizarEmpleado", requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                if (result.codResponse === 1) {
                    setVisible(true);
                    setMessage(result.messageResponse);
                    setShow(false);
                } else {
                    setVisible(true);
                    setMessage("Error al actualizar el empleado:" + result.messageResponse);
                }

                login();
            })
            .catch(error => console.log('error', error));

    }

    const createEmpleado = () => {

        var raw = JSON.stringify({
            "id_empresa": localStorage.getItem('idEmpresa'),
            "Nombre": nombre1Empleado + " " + Apellido1Empleado,
            "RFC": identificacion,
            "NumeroEmpleado": iDInterno,
            "TipoIdentificacion": tipoIdentificacion,
            "TelefonoEmpleadoString": Telefono,
            "CorreoElectronico": correo,
            "PrimerNombre": nombre1Empleado,
            "OtroNombre": nombre2Empleado,
            "PrimerApellido": Apellido1Empleado,
            "SegundoApellido": Apellido2Empleado,
            "SalarioIntegral": SalarioIntegral,
            "Sueldo": Sueldo,
            "NumeroCuenta": NumeroCuenta,
            "DireccionEmpleado": Ubicacion,
            "Banco": IdBanco,
            "TipoCuenta": 1,
            "FormaPago": IdFormaPago,
            "FormaPago": IdFormaPago,
            "MedioPago": 1,
            "Municipio": IdMunicipio,
            "Departamento": IdDepartamento,
            "Pais": IdPais,
            "SubTipoTrabajador": IdtipoSubTrabajador,
            "TipoTrabajador": IdtipoTrabajador,
            "TipoContrato": IdtipoContrato,
            "FechaIngreso": fechaIngreso,
        });

        var requestOptions = {
            method: 'POST',
            headers: new Headers(),
            body: raw,
            redirect: 'follow'
        };

        console.log(raw);

        fetch("./api/Empleado/GuardarEmpleado", requestOptions)
            .then(response => response.json())
            .then(result => {
                let cod = result.codResponse;
                if (cod == 1) {
                    setMessage("El empleado se creo correctamente");
                }
                else {
                    setMessage("Se genero un error de datos al crear empleado");
                }
                console.log(result);
                setVisible(true);
                setShow(false);
                login();
            })
            .catch(error => console.log('error', error));

    }

    const deleteEmpleado = (idCliente) => {
 

        var requestOptions = {
            headers: new Headers(),
            method: 'DELETE',
            redirect: 'follow'
        };

        var url = "./api/Empleado/EliminarEmpleado/" + idCliente;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                let cod = result.codResponse;
                if (cod == 1) {
                    setVisible(true);
                    setMessage("El empleado se elimin\u00f3 correctamente.");
                }
                else {
                    setVisible(true);
                    setMessage("Se genero un error de datos al crear empleado");
                }
                login();
                setShowEliminar(false);
            })
            .catch(error => console.log('error', error));
    }

    const getNovedadesEmpleados = (idCliente) => {




        var requestOptions = {
            headers: new Headers(),
            method: 'GET',
            redirect: 'follow'

        };


        var mes = localStorage.getItem("mes");
        var anio = localStorage.getItem("anio");

        var url = "./api/Novedad/TraerNovedadxEmpleado?iIdEmpleado=" + idCliente + "&shMes=" + mes + "&iAno=" + anio;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                setNovedades(result.basePresentationList);
            })
            .catch(error => console.log('error', error));
    }

    const [showEliminar, setShowEliminar] = React.useState(false);
    const toggleEliminar = () => { setShowEliminar(false); };

    const [IdNovedad, setIdNovedad] = React.useState(0);

    const handleIdNovedad = (e) => {
        setIdNovedad(e.target.value);
    }

    const [dataNovedadLista, setdataNovedades] = React.useState(dataNovedades);
    const novedadesOptions = {};

    const gettiposNovedad = () => {

        var requestOptions = {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow'
        };
        var urlTipoNov = "./api/Auxiliar/ListaTipoNovedad";

        fetch(urlTipoNov, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                dataNovedades = result.basePresentationList;
                setdataNovedades(dataNovedades);

                dataNovedades.map((novedad, index) => {
                    const { Codigo, Descripcion } = novedad;
                    novedadesOptions[index] = Descripcion;
                });

                console.log(novedadesOptions);
                setdataNovedades(novedadesOptions);
            })
            .catch(error => console.log('error', error));
    }

    const createNovedad = (novedad) => {


        var raw = JSON.stringify({
            "Id_empleado": idCliente,
            "Id_producto": novedad.Id_producto,
            "TipoNovedad": novedad.TipoNovedad,
            "EstadoNovedad": 1,
            "FechaRegistro": new Date(),
            "Cantidad": novedad.Cantidad,
            "ValorUnitario": novedad.ValorUnitario,
            "PorcentajeImpto": novedad.con_por_impuesto2,
            "TipoIncapacidad": novedad.TipoIncapacidad,
            "OtroConcepto": novedad.OtroConcepto,
            "FechaInicio": novedad.FechaInicio,
            "FechaFin": novedad.FechaFin,
            "PorcentajeIva": 0,
            "Iva": 0
        });

        var requestOptions = {
            method: 'POST',
            headers: new Headers(),
            body: raw,
            redirect: 'follow'
        };

        fetch("./api/Novedad/CrearNovedad", requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                getNovedadesEmpleados(idCliente);
            })
            .catch(error => console.log('error', error));
    }

    const deleteNovedad = (novedad) => {



        var requestOptions = {
            method: 'DELETE',
            headers: new Headers(),
            redirect: 'follow'
        };
        var url = "./api/Novedad/EliminarNovedad?iIdNovedad=" + novedad;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                console.log(novedad);
                getNovedadesEmpleados(idCliente);
            })
            .catch(error => console.log('error', error));
    }

    var productoID = 0;

    const getproductId = (id, novedad) => {
        console.log(novedad);

        update(novedad);
    }

    const update = (novedad, productokey) => {
        console.log(productoID);

        var raw = JSON.stringify({
            "Id_novedad": novedad.Id_novedad,
            "Id_empleado": idCliente,
            "EstadoNovedad": 1,
            "Id_producto": novedad.Id_producto, //productoID
            "TipoNovedad": novedad.TipoNovedad,
            "Cantidad": novedad.Cantidad,
            "ValorUnitario": novedad.ValorUnitario,
            "PorcentajeImpto": novedad.con_por_impuesto2,
            "TipoIncapacidad": novedad.TipoIncapacidad,
            "OtroConcepto": novedad.OtroConcepto,
            "FechaInicio": novedad.FechaInicio,
            "FechaFin": novedad.FechaFin,
            "FechaRegistro": new Date(),
        });

        console.log(raw);

        var requestOptions = {
            method: 'PUT',
            headers: new Headers(),
            body: raw,
            redirect: 'follow'
        };

        fetch("./api/Novedad/ModificarNovedad", requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                getNovedadesEmpleados(idCliente);
            })
            .catch(error => console.log('error', error));
    }

    const updateNovedad = (novedad) => {
        console.log(novedad);
        var id = novedad.Id_producto;
        getproductId(id, novedad);
    }

    const [showAlertaNoEmp, setShowAlertaNoEmp] = React.useState(false);


    return (
        <>
            <div className="content">

                <Alert color="primary" isOpen={visible} toggle={onDismiss}>
                    {message}
                </Alert>



                <Modal show={showEliminar} onHide={toggleEliminar} >
                    <Modal.Header closeButton>Eliminar Empleado</Modal.Header>
                    <Modal.Body>
                        {"Esta seguro de eliminar el empleado " + idCliente + "?"}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button color="secondary" onClick={toggleEliminar}>Cancelar</Button>{' '}
                        <Button color="primary" onClick={confirmarEliminar}>Eliminar</Button>

                    </Modal.Footer>
                </Modal>
                {/*onClick={handleCloseNovedades}*/}

                <Modal show={showNovedades} onHide={handleCloseNovedades} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Novedades</Modal.Title>
                    </Modal.Header>
                    <Modal.Body> <MaterialTable
                        columns={[

                            {
                                title: 'Tipo de Novedad', field: 'TipoNovedad', initialEditValue: 0, lookup: { 1: "Periodico", 2: "No Periodico" },
                                render: (rowData) => {
                                    return (
                                        rowData.TipoNovedad == 1 ? <p style={{ color: "#E87722", fontWeight: "bold" }}>Peri&#243;dico</p> :
                                            rowData.TipoNovedad == 2 ? <p style={{ color: "#008240", fontWeight: "bold" }}>No Peri&#243;dico</p> :
                                                <p style={{ color: "#B0B700", fontWeight: "bold" }}>No Periodico</p>
                                    );
                                }
                            },
                            {

                                title: 'Novedad', field: 'Id_producto', initialEditValue: 0, lookup: { 252495: 'AFC', 252474: 'Anticipo', 260147: 'Anticipo', 252476: 'ApoyoSost', 252484: 'AuxilioNS', 252483: 'AuxilioS', 250864: 'AuxilioTransporte', 250863: 'Basico', 252482: 'BonificacionNS', 252481: 'BonificacionS', 252478: 'BonifRetiro', 252508: 'Cesantias', 261031: 'Cesant�asIntereses', 260044: 'Comision', 252488: 'CompensacionE', 252487: 'CompensacionO', 260043: 'Concepto Felicitaci�n', 252486: 'ConceptoNS', 252485: 'ConceptoS', 252496: 'Cooperativa', 260144: 'Deducciones-Sindicatos', 252502: 'DeduccionSP', 259658: 'DeduccionSub', 252501: 'Deuda', 252475: 'Dotacion', 252499: 'Educacion', 258811: 'Eliminar Nomina', 252497: 'EmbargoFiscal', 250868: 'FondoPension', 250865: 'HED', 252460: 'HEDDF', 250866: 'HEN', 252462: 'HENDF', 252461: 'HRDDF', 252459: 'HRN', 252463: 'HRNDF', 252465: 'HuelgaLegal', 252464: 'Incapacidad', 252479: 'Indemnizacion', 252506: 'Libranza', 260145: 'Libranza-Cr�dito', 252470: 'LicenciaMP', 252472: 'LicenciaNR', 252471: 'LicenciaR', 252507: 'OtraDeduccion', 252492: 'PagoAlimentacionNS', 252491: 'PagoAlimentacionS', 260042: 'PagoIntereses', 252490: 'PagoNS', 252489: 'PagoS', 252473: 'PagoTercero', 260146: 'PagoTercero', 252493: 'PensionVoluntaria', 252498: 'PlanComplementarios', 252468: 'Primas', 266271: 'PrimasCantidad', 252469: 'PrimasNS', 252500: 'Reintegro', 252480: 'Reintegro', 252494: 'RetencionFuente', 258151: 'SalarioIntegral', 250867: 'Salud', 252505: 'SancionPriv', 252504: 'SancionPublic', 252503: 'Sindicatos', 252477: 'Teletrabajo', 252467: 'VacacionesCompensadas', 252466: 'VacacionesComunes', 252458: 'ViaticoManuAlojNS', 252457: 'ViaticoManuAlojS' },
                                render: (rowData) => {
                                    return (
                                        <p style={{ color: "#E87722", fontWeight: "bold" }}>{rowData.ProductoNombre}</p>
                                    );
                                }
                            },
                            {
                                title: "Cantidad (d/h)",
                                field: "Cantidad",
                                type: "numeric",
                                filtering: true
                            },
                            {
                                title: "Valor Unitario",
                                field: "ValorUnitario",
                                type: "currency",
                                filtering: true
                            }
                            ,
                            {
                                title: "Porcentaje Impuesto",
                                field: "con_por_impuesto2",
                                type: "numeric",
                                filtering: true
                            }
                            ,
                            {
                                title: "Fecha hora inicio",
                                field: "FechaInicio",
                                type: "datetime",
                                filtering: true
                            },
                            {
                                title: "Fecha hora fin",
                                field: "FechaFin",
                                type: "datetime",
                                filtering: true
                            },
                            {
                                title: "texto Libranza",
                                field: "TipoIncapacidad",
                                type: "string",
                                filtering: true
                            },
                            {
                                title: "texto 2",
                                field: "OtroConcepto",
                                type: "string",
                                filtering: true
                            }
                        ]}

                        data={novedades}
                        title="Novedades"
                        onSelectionChange={(newSelection) => {

                        }}
                        icons={tableIcons}

                        options={{
                            filtering: true,
                            selection: true,
                            exportButton: true,
                            exportAllData: true,
                            maxBodyHeight: '800px',

                        }}
                        style={{ fontFamily: 'Hammersmith One' }}
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        console.log(newData);
                                        createNovedad(newData);
                                        /*setState((prevState) => {
                                            const data = [...prevState.data];
                                            console.log(newData);
                                            data.push(newData);
                                            return { ...prevState, data };
                                        });*/
                                    }, 600);
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        if (oldData) {
                                            updateNovedad(newData);
                                            /*setState((prevState) => {
                                                const data = [...prevState.data];
                                                data[data.indexOf(oldData)] = newData;
                                                return { ...prevState, data };
                                            });*/
                                        }
                                    }, 600);
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                        console.log(oldData);
                                        deleteNovedad(oldData.Id_novedad);
                                        /*setState((prevState) => {
                                            const data = [...prevState.data];
                                            data.splice(data.indexOf(oldData), 1);
                                            return { ...prevState, data };
                                        });*/
                                    }, 600);
                                }),
                        }}
                    /></Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseNovedades}>
                            Cerrar
                        </Button>

                    </Modal.Footer>
                </Modal>

                <Modal
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    style={{ fontFamily: 'Hammersmith One' }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Crear Empleado</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* <Nav tabs style={{ marginTop: "-10px" }}>
                          <NavItem>
                              <NavLink
                                  className={classnames({ active: activeTab === '1' })}
                                  onClick={() => { toggle('1'); }}
                              >
                                  Datos Personales
          </NavLink>
                          </NavItem>
                          <NavItem>
                              <NavLink
                                  className={classnames({ active: activeTab === '2' })}
                                  onClick={() => { toggle('2'); }}
                              >
                                  Datos Laborales
          </NavLink>
                          </NavItem>
                      </Nav>
                      <TabContent activeTab={activeTab}>
                          <TabPane tabId="1">
                              
                          </TabPane>
                          <TabPane tabId="2">
                              <h4>Datos laborales del empleado</h4>
                              
                          </TabPane>
                      </TabContent>*/}

                        <Tab.Container id="left-tabs-example" defaultActiveKey="first" style={{ marginTop: "-10px" }}>
                            <Row>
                                <Col sm={2}>
                                    <Nav variant="pills" className="flex-column">
                                        <Media object src={empleadoimg} alt="Generic placeholder image" style={{ marginTop: "-10px" }} />
                                        <Nav.Item style={{ marginTop: "10px" }}>
                                            <Nav.Link eventKey="first">Datos Personales</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item style={{ marginTop: "10px" }}>
                                            <Nav.Link eventKey="second">Datos Laborales</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col sm={10}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <Form style={{ margin: "15px", marginTop: "-20px" }}>
                                                <Row>
                                                    <Col md="3">
                                                        <FormGroup >
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Primer Nombre</Label>
                                                            <Input disabled={!showEdit && !showCreate} onChange={handleNombre1} defaultValue={nombre1Empleado} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Nombre 1" />
                                                            {/*<Input disabled={!showEdit && !showCreate} type="text" name="email" onChange={handleNombre1} defaultValue={nombre1Empleado} id="exampleEmail" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Nombre" />*/}

                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Otros Nombres</Label>
                                                            <Input disabled={!showEdit && !showCreate} onChange={handleNombre2} defaultValue={nombre2Empleado} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Nombre 2" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Primer Apellido</Label>
                                                            <Input disabled={!showEdit && !showCreate} onChange={handleApellido1} defaultValue={Apellido1Empleado} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Apellido" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Segundo Apellido</Label>
                                                            <Input disabled={!showEdit && !showCreate} onChange={handleApellido2} defaultValue={Apellido2Empleado} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Apellido 2" />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md="3">
                                                        <FormGroup >
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Codigo</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="number" onChange={handleiDInterno} defaultValue={iDInterno} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="1236" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Tipo Documento</Label>

                                                            <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" onChange={handletipoIdentificacion} defaultValue={tipoIdentificacion} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                                {dataTiposIdentificacionPersonas.map((tipo, index) =>
                                                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Documento</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="number" onChange={handleidentificacion} defaultValue={identificacion} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="100000000" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "11px" }}>Fecha Ingreso</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="date" onChange={handlefechaIngreso} value={fechaIngreso} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One', padding: 2 }} />
                                                            <FormText>dd/mm/aaaa</FormText>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <hr
                                                    style={{
                                                        color: "#FFFFFF",
                                                        backgroundColor: "#FFFFFF",
                                                        height: 1
                                                    }}
                                                />
                                                <Row>
                                                    <Col md="4">
                                                        <FormGroup >
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Correo</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="email" onChange={handlecorreo} defaultValue={correo} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="correo@gmail.com" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Telefono</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="email" onChange={handleTelefono} defaultValue={Telefono} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="573013000000" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Direccion</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="email" onChange={handleUbicacion} defaultValue={Ubicacion} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Calle 1" />
                                                        </FormGroup>
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col md="4">
                                                        <Label for="exampleEmail" style={{ fontSize: "12px" }}>Pais</Label>

                                                        <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" onChange={handleIdPais} defaultValue={IdPais} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                            {dataPaisesLista.map((tipo, index) =>
                                                                <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                        </Input>
                                                    </Col>
                                                    <Col md="4">
                                                        <Label for="exampleEmail" style={{ fontSize: "12px" }}>Estado/Departamento</Label>

                                                        <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" onChange={handleIdDepartamento} defaultValue={IdDepartamento} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                            {dataDepartamentosLista.map((tipo, index) =>
                                                                <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                        </Input>
                                                    </Col>
                                                    <Col md="4">
                                                        <Label for="exampleEmail" style={{ fontSize: "12px" }}>Ciudad</Label>

                                                        <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" onChange={handleIdMunicipio} value={IdMunicipio} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                            {dataCiudadLista.map((tipo, index) =>
                                                                <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                        </Input>
                                                    </Col>

                                                </Row>
                                            </Form>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <Form>
                                                <Row>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Tipo Contrato</Label>

                                                            <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" onChange={handleIdtipoContrato} defaultValue={IdtipoContrato} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                                {datatipoContratoLista.map((tipo, index) =>
                                                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Tipo Trabajador</Label>

                                                            <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" onChange={handleIdtipoTrabajador} defaultValue={IdtipoTrabajador} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                                {datatipoTrabajadorLista.map((tipo, index) =>
                                                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>SubTipo Trabajador</Label>

                                                            <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" onChange={handleIdtipoSubTrabajador} defaultValue={IdtipoSubTrabajador} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                                {datatipoSubTrabajadorLista.map((tipo, index) =>
                                                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        
                                                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                                            <Form.Check disabled={!showEdit && !showCreate} onChange={handleSalarioIntegral} checked={SalarioIntegral} type="checkbox" label="Salario Integral" />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md="3">
                                                        <FormGroup >
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Sueldo</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="decimal" onChange={handleSueldo} defaultValue={formatter.format(Sueldo)} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="12000000" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Banco</Label>

                                                            <Input disabled={!showEdit && !showCreate} type="select" name="select" onChange={handleIdBanco} defaultValue={IdBanco} id="exampleSelect" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                                {dataBancosLista.map((tipo, index) =>
                                                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Tipo Cuenta</Label>

                                                            <Input disabled={!showEdit && !showCreate} type="select" name="select" id="exampleSelect" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                                <option>Cuenta de Ahorros</option>
                                                                <option>Cuenta Corriente</option>
                                                                <option>3</option>
                                                                <option>4</option>
                                                                <option>5</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Numero de Cuenta</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="number" onChange={handleNumeroCuenta} defaultValue={NumeroCuenta} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="12344543534" />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Forma de Pago</Label>

                                                            <Input disabled={!showEdit && !showCreate} type="select" name="select" onChange={handleIdFormaPago} defaultValue={IdFormaPago} id="exampleSelect" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                                                {dataFormaPagoLista.map((tipo, index) =>
                                                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Condiciones de Pago</Label>
                                                            <Input disabled={!showEdit && !showCreate} type="numeric" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Condiciones" />
                                                        </FormGroup>
                                                    </Col>

                                                </Row>
                                            </Form>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose} style={{ fontFamily: 'Hammersmith One' }}>
                            Cancelar
                        </Button>
                        <Button variant="primary" hidden={!showEdit} style={{ fontFamily: 'Hammersmith One' }} onClick={updateEmpleado}>Grabar cambios empleado</Button>
                        <Button variant="primary" hidden={!showCreate} style={{ fontFamily: 'Hammersmith One' }} onClick={createEmpleado}>Crear empleado</Button>
                    </Modal.Footer>
                </Modal>

                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col sm={6}>
                                        <h3 className="title" style={{ fontFamily: 'Hammersmith One', marginLeft: "15px", marginTop: "10px" }}>Empleados</h3>

                                    </Col>
                                    <Col sm={6} style={{ textAlign: "end" }}>
                                        <Button data-index={"2"} onClick={handleShow} variant="primary" style={{ fontFamily: 'Hammersmith One', marginRight: "15px" }}>Crear empleado</Button>
                                    </Col>
                                </Row>

                            </CardHeader>
                            <CardBody className="all-icons" style={{ margin: "15px", marginTop: "-20px" }}>
                                <Alert variant="filled" severity="warning" isOpen={showAlertaNoEmp}>
                                    <AlertTitle>Bienvenido a eSalarium</AlertTitle>
                                    Aun no tienes empleados registrados, agrega un empleado con el boton CREAR EMPLEADO.
                                </Alert>
                                <Row>

                                    {empleadosDatos.map(renderCard)}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/*<Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <h5 className="title">100 Awesome Nucleo Icons</h5>
                <p className="category">
                  Handcrafted by our friends from{" "}
                  <a href="https://nucleoapp.com/?ref=1712">NucleoApp</a>
                </p>
              </CardHeader>
              <CardBody className="all-icons">
                <Row>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-alert-circle-exc" />
                      <p>icon-alert-circle-exc</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-align-center" />
                      <p>icon-align-center</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-align-left-2" />
                      <p>icon-align-left-2</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-app" />
                      <p>icon-app</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-atom" />
                      <p>icon-atom</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-attach-87" />
                      <p>icon-attach-87</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-badge" />
                      <p>icon-badge</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-bag-16" />
                      <p>icon-bag-16</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-bank" />
                      <p>icon-bank</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-basket-simple" />
                      <p>icon-basket-simple</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-bell-55" />
                      <p>icon-bell-55</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-bold" />
                      <p>icon-bold</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-book-bookmark" />
                      <p>icon-book-bookmark</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-double-right" />
                      <p>icon-double-right</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-bulb-63" />
                      <p>icon-bulb-63</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-bullet-list-67" />
                      <p>icon-bullet-list-67</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-bus-front-12" />
                      <p>icon-bus-front-12</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-button-power" />
                      <p>icon-button-power</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-camera-18" />
                      <p>icon-camera-18</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-calendar-60" />
                      <p>icon-calendar-60</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-caps-small" />
                      <p>icon-caps-small</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-cart" />
                      <p>icon-cart</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-chart-bar-32" />
                      <p>icon-chart-bar-32</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-chart-pie-36" />
                      <p>icon-chart-pie-36</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-chat-33" />
                      <p>icon-chat-33</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-check-2" />
                      <p>icon-check-2</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-cloud-download-93" />
                      <p>icon-cloud-download-93</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-cloud-upload-94" />
                      <p>icon-cloud-upload-94</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-coins" />
                      <p>icon-coins</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-compass-05" />
                      <p>icon-compass-05</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-controller" />
                      <p>icon-controller</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-credit-card" />
                      <p>icon-credit-card</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-delivery-fast" />
                      <p>icon-delivery-fast</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-email-85" />
                      <p>icon-email-85</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-gift-2" />
                      <p>icon-gift-2</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-globe-2" />
                      <p>icon-globe-2</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-headphones" />
                      <p>icon-headphones</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-heart-2" />
                      <p>icon-heart-2</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-html5" />
                      <p>icon-html5</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-double-left" />
                      <p>icon-double-left</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-image-02" />
                      <p>icon-image-02</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-istanbul" />
                      <p>icon-istanbul</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-key-25" />
                      <p>icon-key-25</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-laptop" />
                      <p>icon-laptop</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-light-3" />
                      <p>icon-light-3</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-link-72" />
                      <p>icon-link-72</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-lock-circle" />
                      <p>icon-lock-circle</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-map-big" />
                      <p>icon-map-big</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-minimal-down" />
                      <p>icon-minimal-down</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-minimal-left" />
                      <p>icon-minimal-left</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-minimal-right" />
                      <p>icon-minimal-right</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-minimal-up" />
                      <p>icon-minimal-up</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-mobile" />
                      <p>icon-mobile</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-molecule-40" />
                      <p>icon-molecule-40</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-money-coins" />
                      <p>icon-money-coins</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-notes" />
                      <p>icon-notes</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-palette" />
                      <p>icon-palette</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-paper" />
                      <p>icon-paper</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-pin" />
                      <p>icon-pin</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-planet" />
                      <p>icon-planet</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-puzzle-10" />
                      <p>icon-puzzle-10</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-pencil" />
                      <p>icon-pencil</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-satisfied" />
                      <p>icon-satisfied</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-scissors" />
                      <p>icon-scissors</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-send" />
                      <p>icon-send</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-settings-gear-63" />
                      <p>icon-settings-gear-63</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-settings" />
                      <p>icon-settings</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-wifi" />
                      <p>icon-wifi</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-single-02" />
                      <p>icon-single-02</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-single-copy-04" />
                      <p>icon-single-copy-04</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-sound-wave" />
                      <p>icon-sound-wave</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-spaceship" />
                      <p>icon-spaceship</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-square-pin" />
                      <p>icon-square-pin</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-support-17" />
                      <p>icon-support-17</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-tablet-2" />
                      <p>icon-tablet-2</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-tag" />
                      <p>icon-tag</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-tap-02" />
                      <p>icon-tap-02</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-tie-bow" />
                      <p>icon-tie-bow</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-time-alarm" />
                      <p>icon-time-alarm</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-trash-simple" />
                      <p>icon-trash-simple</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-trophy" />
                      <p>icon-trophy</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-tv-2" />
                      <p>icon-tv-2</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-upload" />
                      <p>icon-upload</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-user-run" />
                      <p>icon-user-run</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-vector" />
                      <p>icon-vector</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-video-66" />
                      <p>icon-video-66</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-wallet-43" />
                      <p>icon-wallet-43</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-volume-98" />
                      <p>icon-volume-98</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-watch-time" />
                      <p>icon-watch-time</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-world" />
                      <p>icon-world</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-zoom-split" />
                      <p>icon-zoom-split</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-refresh-01" />
                      <p>icon-refresh-01</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-refresh-02" />
                      <p>icon-refresh-02</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-shape-star" />
                      <p>icon-shape-star</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-components" />
                      <p>icon-components</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-triangle-right-17" />
                      <p>icon-triangle-right-17</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-button-pause" />
                      <p>icon-button-pause</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-simple-remove" />
                      <p>icon-simple-remove</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-simple-add" />
                      <p>icon-simple-add</p>
                    </div>
                  </Col>
                  <Col
                    className="font-icon-list col-xs-6 col-xs-6"
                    lg="2"
                    md="3"
                    sm="4"
                  >
                    <div className="font-icon-detail">
                      <i className="tim-icons icon-simple-delete" />
                      <p>icon-simple-delete</p>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>*/}
            </div>
        </>
    );

}

export default Icons;
